module.exports = __webpack_public_path__ + "img/misc.f9e04c53.png";